import { MaterialDesignContent } from "notistack";
import styled from "styled-components";
import variables from "Styles/variables.scss";
export const BASE_URL = "http://localhost:3000/quotes-api";

export const MOBILE_WIDTH = 800; // px

export const ORDERBOOK_LEVELS = 25; // rows count

export const MESSAGES = {
  API_ERROR: "Something went wrong !",
  QUOTES_CREATE_SUCCESS: "Quotes Created Successfully !",
  QUOTES_POST_CREATE_SUCCESS: "Quotes Post Created Successfully !",
  QUOTES_POST_UPDATE_SUCCESS: "Quotes Post Updated Successfully !",
  SUCCESS_LOGIN: "Admin Login Successfully !",
  INSTRUMENT_CREATE_SUCCESS: "Instrumnet Create Successfully !",
  INSTRUMENT_ASSOCIATE: "Instrument Associate Successfully !",
  INSTRUMENT_DEASSOCIATE: "Instrument Dissociate Successfully !"
};
// Function to split hyphen to empty space
export const splitConversion = (value) => {
  try {
    // Split the string by hyphen and join with empty space
    const convertedString = value
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return convertedString;
  } catch (error) {
    // Handle the error as needed
    return null;
  }
};
export const STATUS = {
  PENDING: "PENDING",
  SENT: "SENT",
  EXPIRED: "EXPIRED",
  NEGOTIATING: "NEGOTIATING",
  ORDER_SUBMITTED: "ORDER SUBMITTED",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED"
};
//  Furniture stage label
export const FURNITURE_STAGE = {
  furniture_final_amount_check: "Furniture Amount",
  furniture_security_check: "Security Amount",
  furniture_remaining_amount_check: "Remaining Amount"
};
export const MATERIAL_STAGE = {
  material_ready_to_bill: "Ready To Bill"
};

export const ROLE = {
  DEALER: "DEALER",
  INVESTOR: "INVESTOR"
};

export const snackBarSuccessConf = {
  variant: "success",
  anchorOrigin: { vertical: "top", horizontal: "right" }
};

export const snackBarErrorConf = {
  variant: "error",
  anchorOrigin: { vertical: "top", horizontal: "right" }
};

export const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-success": {
    fontSize: variables.defaultFontSize
  },
  "&.notistack-MuiContent-error": {
    fontSize: variables.defaultFontSize
  }
}));

// Field mapping between Local and API
export const UploadFormFieldsPuc = [
  { key: "profile_photo", label: "profilePhoto" },
  { key: "signature_img", label: "signature" },
  { key: "id_proof", label: "idProof" },
  { key: "address_proof", label: "addressProof" },
  { key: "bank_proof", label: "bankProof" },
  { key: "shop_photo", label: "shopPhotos" },
  { key: "other_doc", label: "shopProof" },
  { key: "gst", label: "gst" },
  { key: "aoa", label: "aoa" },
  { key: "directors", label: "directors" },
  { key: "shareholders", label: "shareholders" }
];



export const notificationmsg = [
  {
    message:
      "Document lorem ipsum  dolar sit amet, consectetur Document venenatis augue nec lectus, consectetur",
    updated: "1 minutes ago"
  },
  {
    message:
      "Document venenatis augue nec lectus, consectetur Document venenatis augue nec lectus, consectetur ",
    updated: "2 minutes ago"
  },
  {
    message:
      "Document venenatis augue nec lectus, consectetur Document venenatis augue nec lectus, consectetur",
    updated: "3 minutes ago"
  },
  {
    message:
      "Document lorem ipsum  dolar sit amet, consectetur Document venenatis augue nec lectus, consectetur",
    updated: "4 minutes ago"
  },
  {
    message:
      "Document venenatis augue nec lectus, consectetur Document venenatis augue nec lectus, consectetur ",
    updated: "5 minutes ago"
  },
  {
    message:
      "Document lorem ipsum  dolar sit amet, consectetur Document venenatis augue nec lectus, consectetur Document venenatis augue nec lectus, consectetur ",
    updated: "6 minutes ago"
  },
  {
    message:
      "Document lorem ipsum  dolar sit amet, consectetur Document venenatis augue nec lectus, consectetur Document venenatis augue nec lectus, consectetur ",
    updated: "6 minutes ago"
  }
];
